import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { Store } from '@ngrx/store';
import { getToken } from '../../store/order/order.selectors';
import { SetToken, SetRefreshToken, SetRefreshTokenValidUntil } from '../../store/order';

/**
 * If log in via user id,
 * do it first then come back w/ token
 * for the http call used in next guard(s)
 */
@Injectable({
  providedIn: 'root'
})
export class LoginViaJwtFirstGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService, private store: Store) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const jwt = route.queryParams.jwt;
    if (!jwt) return true; // We are not logging in via JWT, so we can proceed

    this.store.dispatch(new SetToken(jwt))

    return this.store.select(getToken).pipe(map(currentToken => {
      if (currentToken === jwt) {
        this.store.dispatch(new SetRefreshToken(null))
        this.store.dispatch(new SetRefreshTokenValidUntil(null))
        this.authService.refreshUserInfo(jwt)
      } else {
        const currentUrl = new URL(location.href);
        currentUrl.searchParams.delete('jwt') // remove JWT param
        const futureRedirection = currentUrl.pathname + currentUrl.search
        this.router?.navigateByUrl(`/?login=true&login-redirect-url=${futureRedirection}`);
      }
      return true
    }))
  }
}
